/*
  LA sepet hediyesi (snippets/la-hediye.liquid). Sepeti /cart.js'ten okur:
  - hediye HARİÇ ücretli satırların toplamı eşiğin altındaysa: "X daha ekle" + çubuk
  - eşik aşıldıysa hediyeyi `_hediye` özelliğiyle sepete ekler (fiyatı Shopify'ın otomatik
    indirimi $0 yapar); altına düşülürse otomatik eklenen hediyeyi çıkarır.
  - Müşteri hediyeyi kendisi silerse o oturumda geri eklemez.
*/
(function () {
  if (window.__laHediye) return;
  window.__laHediye = true;
  var para;
  try { para = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); }
  catch (e) { para = { format: function (n) { return '$' + n.toFixed(2); } }; }
  var mesgul = false, bekleyen = false;
  var ss = { al: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, koy: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  function kutular() { return document.querySelectorAll('[data-la-hediye]'); }

  function ciz(c) {
    kutular().forEach(function (k) {
      var esik = parseInt(k.getAttribute('data-esik'), 10), vid = k.getAttribute('data-variant');
      var nitelikli = 0;
      (c.items || []).forEach(function (i) { if (i.price > 0 && String(i.variant_id) !== vid) nitelikli += i.original_line_price; });
      var hediyeVar = (c.items || []).some(function (i) { return String(i.variant_id) === vid; });
      var metin = k.querySelector('[data-hediye-metin]'), dolu = k.querySelector('[data-hediye-dolu]');
      var ad = k.getAttribute('data-ad'), deger = k.getAttribute('data-deger');
      k.hidden = !(c.item_count > 0);
      var oran = Math.min(100, Math.round(nitelikli / esik * 100));
      dolu.style.width = oran + '%';
      k.classList.toggle('la-hediye--tamam', nitelikli >= esik);
      if (nitelikli >= esik) {
        metin.innerHTML = hediyeVar
          ? '<strong>Free gift unlocked:</strong> ' + ad + ' (' + deger + ' value) is in your cart.'
          : '<strong>Free gift unlocked:</strong> ' + ad + ' (' + deger + ' value).';
      } else {
        metin.innerHTML = 'Add <strong>' + para.format((esik - nitelikli) / 100) + '</strong> more and get <strong>' + ad + '</strong> free (' + deger + ' value).';
      }
    });
  }

  /* ---- Sepet önerileri: sepetteki ücretli ürünlerin "Pairs well with" eşleri ---- */
  var esOnbellek = {};
  function esleriAl(handle) {
    if (esOnbellek[handle]) return Promise.resolve(esOnbellek[handle]);
    var k = 'la-es-' + handle, s = ss.al(k);
    if (s) { try { esOnbellek[handle] = JSON.parse(s); return Promise.resolve(esOnbellek[handle]); } catch (e) {} }
    return fetch('/products/' + encodeURIComponent(handle) + '?view=la-esles-json').then(function (r) { return r.json(); })
      .then(function (j) { esOnbellek[handle] = j; ss.koy(k, JSON.stringify(j)); return j; })
      .catch(function () { return { esler: [] }; });
  }
  function kacis(x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function oneriler(c) {
    var kutu = document.querySelector('[data-la-oneri]'), hk = kutular()[0];
    if (!kutu || !hk) return;
    var vid = hk.getAttribute('data-variant'), esik = parseInt(hk.getAttribute('data-esik'), 10);
    var sepette = {}, nitelikli = 0;
    (c.items || []).forEach(function (i) { sepette[String(i.variant_id)] = 1; if (i.price > 0 && String(i.variant_id) !== vid) nitelikli += i.original_line_price; });
    if (!c.item_count) { kutu.hidden = true; return; }
    var kaynaklar = (c.items || []).filter(function (i) { return i.price > 0 && String(i.variant_id) !== vid; }).slice(0, 3);
    Promise.all(kaynaklar.map(function (i) { return esleriAl(i.handle).then(function (j) { return { j: j, kaynak: i.product_title }; }); }))
      .then(function (sonuc) {
        var aday = [], gor = {};
        sonuc.forEach(function (s) { (s.j.esler || []).forEach(function (e) {
          if (!sepette[String(e.id)] && !gor[e.id] && String(e.id) !== vid) { gor[e.id] = 1; e.kaynak = s.kaynak; aday.push(e); }
        }); });
        if (!aday.length) {
          var yedek = [];
          try { yedek = JSON.parse(kutu.querySelector('[data-oneri-yedek]').textContent); } catch (e) {}
          yedek.forEach(function (e) { if (!sepette[String(e.id)] && !gor[e.id]) { gor[e.id] = 1; e.kaynak = 'Cart'; aday.push(e); } });
        }
        // Hediyeye kalan varsa ve eşlerden hiçbiri kalanı tek başına kapatmıyorsa,
        // yedek listeden kapatan en ucuz çok satanı ekle (kalan tek tıkla kapansın)
        var kalan = esik - nitelikli;
        if (kalan > 0 && !aday.some(function (e) { return e.p >= kalan; })) {
          var yedek2 = [];
          try { yedek2 = JSON.parse(kutu.querySelector('[data-oneri-yedek]').textContent); } catch (e) {}
          var kapatan = yedek2.filter(function (e) { return e.p >= kalan && !sepette[String(e.id)] && !gor[e.id]; })
            .sort(function (a, b) { return a.p - b.p; })[0];
          if (kapatan) { kapatan.kaynak = 'Cart'; aday.unshift(kapatan); }
        }
        if (kalan > 0) aday.sort(function (a, b) { var ak = a.p >= kalan, bk = b.p >= kalan; if (ak !== bk) return ak ? -1 : 1; return ak ? a.p - b.p : b.p - a.p; });
        // 4'e tamamla: eksik yerleri en çok satanlarla doldur (sepette olanlar hariç)
        if (aday.length < 4) {
          var dolgu = [];
          try { dolgu = JSON.parse(kutu.querySelector('[data-oneri-yedek]').textContent); } catch (e) {}
          dolgu.forEach(function (e) { if (aday.length < 4 && !sepette[String(e.id)] && !aday.some(function (a) { return a.id === e.id; })) { e.kaynak = 'Cart'; aday.push(e); } });
        }
        aday = aday.slice(0, 4);
        var d = window.laKampanyaEtkin ? window.laKampanyaEtkin() : null;
        var oran = d && d.tur === 'satis' ? d.oran : 0;
        kutu.querySelector('[data-oneri-liste]').innerHTML = aday.map(function (e) {
          var fiyat = oran ? '<s>' + para.format(e.p / 100) + '</s> <strong>' + para.format((e.p - Math.round(e.p * oran / 100)) / 100) + '</strong>'
            : (e.c > e.p ? '<s>' + para.format(e.c / 100) + '</s> ' : '') + '<strong>' + para.format(e.p / 100) + '</strong>';
          var kapatir = kalan > 0 && e.p >= kalan ? '<em class="la-oneri__rozet">Unlocks your free gift</em>' : '';
          return '<li class="la-oneri__kart">' + kapatir +
            '<a class="la-oneri__gorsel" href="' + kacis(e.u) + '">' + (e.i ? '<img src="' + kacis(e.i.replace('width=160', 'width=400')) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<a class="la-oneri__ad" href="' + kacis(e.u) + '">' + kacis(e.t) + '</a>' +
            '<span class="la-oneri__fiyat">' + fiyat + '</span>' +
            '<button type="button" class="la-oneri__ekle" data-oneri-ekle="' + e.id + '" data-oneri-kaynak="' + kacis(e.kaynak || 'Cart') + '" aria-label="Add ' + kacis(e.t) + ' to cart">+ Add to cart</button></li>';
        }).join('');
        kutu.hidden = !aday.length;
      });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-oneri-ekle]');
    if (!b) return;
    ev.preventDefault();
    b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-oneri-ekle'), 10), quantity: 1, properties: { _pair: 'Cart: ' + b.getAttribute('data-oneri-kaynak') } }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); b.textContent = 'Added ✓'; })
      .catch(function () { b.disabled = false; b.textContent = '+ Add to cart'; })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
      });
  });

  function yenile() {
    var k = kutular()[0];
    if (!k) return;
    if (mesgul) { bekleyen = true; return; }
    mesgul = true;
    var esik = parseInt(k.getAttribute('data-esik'), 10), vid = k.getAttribute('data-variant');
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var nitelikli = 0, hediye = null;
      (c.items || []).forEach(function (i) {
        if (String(i.variant_id) === vid) hediye = i;
        else if (i.price > 0) nitelikli += i.original_line_price;
      });
      // Müşteri otomatik eklenen hediyeyi sildiyse bir daha ekleme
      if (!hediye && ss.al('la-hediye-eklendi') === '1' && nitelikli >= esik) ss.koy('la-hediye-kaldirildi', '1');
      var islem = null;
      if (nitelikli >= esik && !hediye && ss.al('la-hediye-kaldirildi') !== '1') {
        islem = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: { _hediye: '1' } }] }) })
          .then(function () { ss.koy('la-hediye-eklendi', '1'); });
      } else if (nitelikli < esik && hediye && hediye.properties && hediye.properties._hediye) {
        islem = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: hediye.key, quantity: 0 }) })
          .then(function () { ss.koy('la-hediye-eklendi', '0'); });
      }
      if (!islem) { ciz(c); oneriler(c); return null; }
      return islem.then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { ciz(c2); oneriler(c2); });
      });
    }).catch(function () {}).then(function () {
      mesgul = false;
      if (bekleyen) { bekleyen = false; setTimeout(yenile, 200); }
    });
  }

  ['theme:cart:add', 'theme:cart:change', 'theme:cart:refresh', 'theme:cart-drawer:show'].forEach(function (ad) {
    document.addEventListener(ad, function () { setTimeout(yenile, 700); });
  });
  // Çekmece kendi içeriğini yenileyince (adet değişimi vb.) tekrar bak
  var son = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-items-holder], cart-items, .cart__table-body')) {
      var t = Date.now(); if (t - son > 300) { son = t; setTimeout(yenile, 1200); }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', yenile); else yenile();
})();
